// /Users/caffas/Documents/Sistemas/vsadmin/admin/admin-app/src/Pages/Users/CustomerAvatar.js
import { useRecordContext } from "react-admin";
import { Avatar } from "@mui/material";

export const CustomerAvatar = ({ size = "normal" }) => {
  const record = useRecordContext();
  if (!record) return null;
  
  return (
    <Avatar
      src={record.avatar}
      sx={size === "small" ? { width: 44, height: 44 } : {}}
    />
  );
};